import gql from "graphql-tag";

export const MY_LEAVE_GET_IS_VIEWER_CONTRACT = gql`
  query isViewerContract($contract: String!) {
    isViewerContract(contract: $contract)
  }
`;
